import React from 'react';
import { Radio, Select } from '@meitu/saas-ui';
import { CustomTitle } from '@meitu/saas-ui/es/title';
import { CanvasType } from '@meitu/saas-editor-core/es/version-types';
import { isEditAIPPTComponent, isUploadAIPPTComponent } from '@/hooks/fetch-template/editor-mode';
import { editor } from '@/instance';
import { SmartComponentTypeOptions } from '../../../ppt-mark-panel/tag-list-config';

export const PptPoster: React.FC<{ canvasType: CanvasType; setCanvasType: Function }> = React.memo(
    ({ canvasType, setCanvasType }) => {
        const pptOptions = [
            { label: '是', value: CanvasType.PPT },
            { label: '否', value: CanvasType.VARIETY },
        ];

        if (canvasType !== CanvasType.VARIETY && canvasType !== CanvasType.PPT) return null;

        return (
            <CustomTitle
                leftNode={
                    <div
                        style={{
                            color: 'var(--content-system-secondary)',
                            fontWeight: 'bold',
                        }}
                    >
                        是否为 PPT 模板
                    </div>
                }
                rightNode={
                    <div>
                        <Radio.Group
                            style={{ margin: 0, alignItems: 'center' }}
                            value={canvasType}
                            onChange={(e) => {
                                setCanvasType(e.target.value);
                            }}
                            options={pptOptions}
                        ></Radio.Group>
                    </div>
                }
            />
        );
    },
);

export const IsSmartComponent = React.memo(({ extraInfo, setExtraInfo }: { extraInfo: any; setExtraInfo: any }) => {
    const materialTypeOptions = [
        { label: '是', value: 'ai_ppt_smart_component' },
        { label: '否', value: 'ai_ppt_component' },
    ];

    if (!isUploadAIPPTComponent()) return null;

    return (
        <CustomTitle
            leftNode={
                <div
                    style={{
                        color: 'var(--content-system-secondary)',
                        fontWeight: 'bold',
                    }}
                >
                    是否为智能组件:
                </div>
            }
            rightNode={
                <div>
                    <Radio.Group
                        style={{ margin: 0, alignItems: 'center' }}
                        value={extraInfo.materialType}
                        onChange={(e) => {
                            setExtraInfo({
                                ...(extraInfo || {}),
                                materialType: e.target.value,
                                componentType: e.target.value === undefined,
                            });
                        }}
                        options={materialTypeOptions}
                    ></Radio.Group>
                </div>
            }
        />
    );
});

export const SmartComponentType = ({ extraInfo, setExtraInfo }: { extraInfo: any; setExtraInfo: any }) => {
    if (!isUploadAIPPTComponent() && !isEditAIPPTComponent()) return null;
    if (extraInfo.materialType !== 'ai_ppt_smart_component') return null;
    return (
        <CustomTitle
            leftNode={
                <div
                    style={{
                        color: 'var(--content-system-secondary)',
                        fontWeight: 'bold',
                    }}
                >
                    智能组件类型:
                </div>
            }
            rightNode={
                <div>
                    <Select
                        style={{
                            margin: 0,
                            alignItems: 'center',
                            width: '80px',
                        }}
                        value={extraInfo.componentType}
                        onChange={(value) => {
                            setExtraInfo({
                                ...(extraInfo || {}),
                                componentType: value,
                            });
                        }}
                        options={SmartComponentTypeOptions}
                    />
                </div>
            }
        />
    );
};

export const SmartComponentPoints = ({ extraInfo }: { extraInfo: any }) => {
    const activeStageIndex = editor.active.getActiveStageIndex();
    const stageExtraInfo = editor.stage.getExtraInfo(activeStageIndex);

    const smartComponentTypeOptions = [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
    ];

    if (!isUploadAIPPTComponent() && !isEditAIPPTComponent) return null;
    if (extraInfo.materialType !== 'ai_ppt_smart_component') return null;

    return (
        <CustomTitle
            leftNode={
                <div
                    style={{
                        color: 'var(--content-system-secondary)',
                        fontWeight: 'bold',
                    }}
                >
                    点数:
                </div>
            }
            rightNode={
                <div>
                    <Select
                        style={{
                            margin: 0,
                            alignItems: 'center',
                            width: '80px',
                        }}
                        value={stageExtraInfo.extraInfo?.componentPoint}
                        onChange={(value) => {
                            if (!stageExtraInfo.extraInfo) {
                                stageExtraInfo.extraInfo = {};
                            }
                            stageExtraInfo.extraInfo.componentPoint = value;
                            editor.stage.setExtraInfo(activeStageIndex, stageExtraInfo);
                        }}
                        options={smartComponentTypeOptions}
                    ></Select>
                </div>
            }
        />
    );
};
